export enum Variant {
    PRIMARY = 'primary',
    PRIMARY_ALTERNATIVE = 'primary-alternative',
    SECONDARY = 'secondary',
    SECONDARY_ALTERNATIVE = 'secondary-alternative',
    ATTENTION = 'attention',
    TERTIARY = 'tertiary',
    /** @deprecated Use {@link Variant.TERTIARY} instead. TEXT renders identically and will be removed in a future release. */
    TEXT = 'text',
    /** @deprecated Use {@link Variant.TERTIARY} or a link instead. A11Y will be removed in a future release. */
    A11Y = 'a11y',
    IMPORTANT = 'important',
    GRAYSCALE = 'grayscale',
}

export enum Size {
    LARGE = 'large',
    NORMAL = 'normal',
    SMALL = 'small',
    TINY = 'xSmall',
}
export type Sizes = `${Size}`;

export enum InformationType {
    INFO = 0,
    ERROR = 10,
}
